import { AlertTriangle, Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ActionBanner } from '@admin/components/banner/action-banner.tsx';
import { useWorkspaceConfiguration } from './use-workspace-configuration.ts';

/*
 * Avertit les administrateurs que les configurations DNS ou e-mail du workspace sont manquantes ou incorrectes.
 */
interface WorkspaceMisconfiguredBannerProps {
  // Inutile sur la page « Informations programme », vers laquelle le bouton redirige
  showAction?: boolean;
}

export const WorkspaceMisconfiguredBanner = ({
  showAction = true
}: WorkspaceMisconfiguredBannerProps = {}) => {
  const { t } = useTranslation();
  const { canManage, isMisconfigured } = useWorkspaceConfiguration();

  if (!canManage || !isMisconfigured) {
    return null;
  }

  return (
    <ActionBanner
      variant="warning"
      icon={AlertTriangle}
      action={
        showAction
          ? {
              label: t('workspace.configuration.banner.button'),
              icon: Settings,
              to: '/settings/my-workspace'
            }
          : undefined
      }
    >
      <p className="text-sm font-semibold leading-relaxed">
        {t('workspace.configuration.banner.title')}
      </p>
      <p className="text-sm leading-relaxed">{t('workspace.configuration.banner.description')}</p>
    </ActionBanner>
  );
};
